import LySubmitButton from './src/index.vue'

LySubmitButton.install = function (Vue) {
    Vue.component(LySubmitButton.name, LySubmitButton)
}

export default LySubmitButton



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/submit-button/index.js
// module id = null
// module chunks = 